<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { deviceDetection } from "@pureadmin/utils";
import Player from "xgplayer";
import "xgplayer/dist/index.min.css";

// 使用 Composition API 获取路由信息
const route = useRoute();
const router = useRouter();
// 使用 ref 创建响应式数据
const videoUrl = ref(route.params.fileUrl);
const getBack = () => {
  // 使用路由参数中的 id 进行跳转
  // router.push({ name: "resourcemana", params: { id: route.params.id } });
  router.go(-1);
};

onMounted(() => {
  new Player({
    el: document.getElementById("mse"), // 确保播放器绑定到正确的元素
    width: "800px", //播放器宽度
    height: "450px", //播放器高度
    id: "mse",
    lang: "zh",
    volume: 0,
    autoplay: false,
    screenShot: true,
    videoAttributes: {
      crossOrigin: "anonymous",
    },
    url: `http://111.35.64.52:30189/api/video?videoUrl=${videoUrl.value}`, // 使用 ref 必须通过 .value 访问数据

    fluid: deviceDetection(),
    playbackRate: [0.5, 0.75, 1, 1.5, 2],
  });
});
</script>

<template>
  <el-card shadow="never">
    <!-- 播放器容器 -->
    <div id="player-wrapper">
      <!-- 返回按钮 -->
      <el-button class="back" type="text" @click="getBack">返回</el-button>
      <!-- 播放器 -->
      <div id="mse"></div>
    </div>
  </el-card>
</template>

<style scoped>
/* 播放器外部容器 */
#player-wrapper {
  position: relative;
  /* 使内部元素可以相对定位 */
  width: 800px;
  height: 450px;
  margin: auto;
}

/* 播放器样式 */
#mse {
  width: 100%;
  height: 100%;
}

/* 返回按钮样式 */
.back {
  position: absolute;
  /* 相对于 #player-wrapper 定位 */
  top: 10px;
  /* 距离顶部 10px */
  left: 10px;
  /* 距离左侧 10px */
  z-index: 10;
  /* 确保按钮显示在视频播放器上方 */
  background-color: transparent;
  /* 透明底色 */
  color: white;
  /* 按钮文字颜色 */
  border: none;
  /* 去掉按钮边框 */
  font-size: 14px;
  /* 调整文字大小 */
  cursor: pointer;
  /* 鼠标移入时显示手型 */
}
</style>
